export const getPolygonDrawColors = (colors: { polygonEditVertexColor: string; selectedZoneColor: string }) => [
  {
    id: 'gl-draw-polygon-fill-inactive',
    paint: {
      'fill-color': colors.selectedZoneColor,
      'fill-opacity': 0.1,
      'fill-outline-color': colors.selectedZoneColor
    },
    type: 'fill'
  },
  {
    id: 'gl-draw-polygon-fill-active',
    paint: {
      'fill-color': colors.selectedZoneColor,
      'fill-opacity': 0.1,
      'fill-outline-color': colors.selectedZoneColor
    },
    type: 'fill'
  },
  {
    id: 'gl-draw-polygon-midpoint',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  },
  {
    id: 'gl-draw-polygon-stroke-inactive',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': colors.selectedZoneColor,
      'line-dasharray': [2, 4],
      'line-width': 2
    },
    type: 'line'
  },
  {
    id: 'gl-draw-polygon-stroke-active',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': colors.selectedZoneColor,
      'line-dasharray': [2, 4],
      'line-width': 2
    },
    type: 'line'
  },
  {
    id: 'gl-draw-line-inactive',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': colors.selectedZoneColor,
      'line-dasharray': [2, 4],
      'line-width': 2
    },
    type: 'line'
  },
  {
    id: 'gl-draw-line-active',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': colors.selectedZoneColor,
      'line-dasharray': [2, 4],
      'line-width': 2
    },
    type: 'line'
  },
  {
    id: 'gl-draw-polygon-and-line-vertex-stroke-inactive',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  },
  {
    id: 'gl-draw-polygon-and-line-vertex-inactive',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  },
  {
    id: 'gl-draw-point-point-stroke-inactive',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  },
  {
    id: 'gl-draw-point-inactive',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  },
  {
    id: 'gl-draw-point-stroke-active',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  },
  {
    id: 'gl-draw-point-active',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  },
  {
    id: 'gl-draw-polygon-fill-static',
    paint: {
      'fill-color': colors.selectedZoneColor,
      'fill-opacity': 0.1,
      'fill-outline-color': colors.selectedZoneColor
    },
    type: 'fill'
  },
  {
    id: 'gl-draw-polygon-stroke-static',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': colors.selectedZoneColor,
      'line-dasharray': [2, 4],
      'line-width': 2
    },
    type: 'line'
  },
  {
    id: 'gl-draw-line-static',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': colors.selectedZoneColor,
      'line-dasharray': [2, 4],
      'line-width': 2
    },
    type: 'line'
  },
  {
    id: 'gl-draw-point-static',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    type: 'circle'
  }
];
